
import { ScorePoint } from './../../../../../models/reporting/score-point.model';
import { Component, OnInit, Input } from '@angular/core';
import { 
  DetailReportQuestion, ParticipantCategoryNames, 
  DetailReportAnswer, DetailReportParticipantCategory, ParticipantCategoryType 
} from '../../../../../models/reporting';
import { ReportingService } from '../../../../../services/reporting.service';
import { MathRoundHelper } from '../../../../../helpers';

@Component({
  selector: 'app-category-question',
  templateUrl: './category-question.component.html',
  styles: []
})
export class CategoryQuestionComponent implements OnInit {
@Input() detailReportQuestion: DetailReportQuestion;
respondentAssesment: Array<DetailReportParticipantCategory>;
otherRespondentGroup: Array<DetailReportParticipantCategory>;

 constructor() { }

  ngOnInit() {
    this.fillEmptyAnswers();
    this.detailReportQuestion.participantCategories.sort((a, b) => {
      return +a.participantCategoryType - +b.participantCategoryType;
    });
    this.sortScaleValue();
    this.detailReportQuestion.participantCategories
    .forEach(x => {
      x.averageValue = MathRoundHelper.roundToFixedNumber(x.averageValue, 1);
    });
    this.hideZeroComparisonGroup();
    this.respondentAssesment = this.detailReportQuestion.participantCategories
    .filter(x => this.GetIsRespondentsAssessmentGroup(x));
    this.otherRespondentGroup = this.detailReportQuestion.participantCategories
    .filter(x => !this.GetIsRespondentsAssessmentGroup(x));
  }

  fillEmptyAnswers() {
    this.detailReportQuestion.participantCategories.forEach(
      x => { 
        if (!x.answers) {
          return;
        }
        if (x.answers.length - 1 === this.detailReportQuestion.scale.maxValue) {
          return;
        }
        const answers: Array<DetailReportAnswer> = [];
        this.detailReportQuestion.scale.values.forEach(v => {
          const answer: DetailReportAnswer = {value: v.value, 
            respondentCount: (x.answers.findIndex(i => i.value === v.value) !== -1) ? 
            x.answers.find(val => val.value === v.value).respondentCount : 0
          };
          answers.push(answer);
        });
        x.answers = this.sortAnswerValues(answers);
      }
    );
  }

  private sortScaleValue() {
    this.detailReportQuestion.scale.values.sort((v1, v2) => {
      return v1.value - v2.value;
    });
  }

  private sortAnswerValues(answers: Array<DetailReportAnswer>) {
    return answers.sort((a1, a2) => a1.value - a2.value);
  }

  private hideZeroComparisonGroup() {
   const comparisonIndex = this.detailReportQuestion.participantCategories
   .findIndex(x => x.participantCategoryType === +ParticipantCategoryNames.ComparisonGroup);
   if (comparisonIndex === -1) {
     return;
   }
   const comparisonValue = this.detailReportQuestion.participantCategories[comparisonIndex].averageValue;
   if (comparisonValue === 0) {
    this.detailReportQuestion.participantCategories.splice(comparisonIndex, 1);
   }
  }

  private GetIsRespondentsAssessmentGroup(question: DetailReportParticipantCategory): boolean {
    return question.participantCategoryType !== +ParticipantCategoryType.ComparisonGroup && 
    question.participantCategoryType !== +ParticipantCategoryType.Self;
  }
}
